//
// Report.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./BaseReport";
import "../media/ReportManifest";
import "./DownloadStatus";
import "./DisplayRecord";
import "./UpdateCharacteristic";
import "../media/AlertableElement";
import "../media/particles/Duid";
import "./ReportAuxiliary";

var Report = createModule("transport_Report", [130,13,50372,50036,50275], EventDispatcher, [
    {
        DOWNLOAD_STARTED: 60101,
        DOWNLOAD_COMPLETED: 60102,
        DATA_UPDATED: 60103,
        THUMBNAIL_GENERATED: 60100,
    },
    {
        displayRecord: 1,
        updateCharacteristic: 4,
        manifest: 1,
        parentCollections: [7],
        duids: [1],
        alertableItems: [1],
        globalLastViewed: 9,
        subscribedFolders: [7],
        auxiliary: 1,
        favoritesCounter: 3,
        originReport: 1,
        isZombie: 2,
        dataLastModified: 9,
        downloadStatus: 1,
        hasIgnoredChange: 2,
        isFavorite: 2,
    },
    ,
    ,
    {
        restoreManifest: [2,7],
        isTransient: [2],
        saveManifest: [2,7],
    },
    {
        _create: [4],
    },
    ,
]);
export default Report;
